import { Expansion } from '../../../types';
import { PropertyOption } from '../../../types/shared';

export const expansionFilterOptions = (
    expansions: Expansion[] | null,
): PropertyOption[] =>
    (expansions ?? []).map((expansion) => ({
        id: expansion.id,
        name: expansion.name.trim(),
        slug: expansion.slug,
        badge: expansion.tag,
    }));
